module.exports = __webpack_public_path__ + "img/instam-arrow-left.156c0f68.svg";